import React, { Component } from 'react'

import Header from './common/EmptyHeader'
import Footer from './common/GreenFooter'

class PriceDetail extends Component {
    render() {
        return (
            <div className="static-page">
                <Header />
                <main>
                    <div className="container-fluid" style={{ marginBottom: '120px' }}>
                        <div className="row" style={{ paddingTop: '40px' }}>
                            <div className="container">
                                <div className="row" style={{ marginBottom: '16px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <h1>收費標準</h1>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '24px' }} id="data-process-fee">
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <h2>資料處理費</h2>
                                        <div className="row">
                                            <div className="col-12">
                                                <p style={{ color: '#4a4f55', margin: '8px 0 0 0', fontSize: '0.875rem' }}>按瓶入庫收取，單次收費</p>
                                                <div className="price">
                                                    <div className="detail">
                                                        <p style={{ textDecoration: 'line-through' }}>定　價：$25／瓶</p>
                                                        <p className="f-red">優惠價：$20／瓶</p>
                                                    </div>
                                                </div>
                                                <p style={{ margin: '8px 0 0 0', fontSize: '0.875rem', color: '#9fa2a3' }}>*處理費可以幫助 CELLWINE 持續讓您享受更優質的藏酒服務，其中包含CELLWINE系統維運費、每瓶瓶身保護包材與攝影紀錄費。</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" id="storage-fee" style={{ marginBottom: '24px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <h2>葡萄酒儲存費</h2>
                                        <div className="row">
                                            <div className="col-12">
                                                <p style={{ color: '#4a4f55', margin: '8px 0 0 0', fontSize: '0.875rem' }}>按瓶單月收取，每月收費</p>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>入窖當月</th>
                                                                <th>次月至第 12 個月</th>
                                                                <th>第 13 個月及以上</th>
                                                                {/* <th>第 25 個月及以上</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <th>免費</th>
                                                                <td>$20</td>
                                                                <td>$16</td>
                                                                {/* <td>$8</td> */}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: '24px' }} id="cellar-process-fee">
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <h2>服務費</h2>
                                        <div className="row">
                                            <div className="col-12">
                                                <p style={{ color: '#4a4f55', margin: '8px 0 0 0', fontSize: '0.875rem' }}>按瓶出庫收取，單次收費</p>
                                                <div className="price">
                                                    <div className="detail">
                                                        <p>一般取件: $15／瓶 (兩個工作天前預約取酒)</p>
                                                        <p>隔日急件: $100／瓶 (一個工作天前預約取酒)</p>
                                                        <p>當日特急件: $200／瓶 (當天上午11點前預約取酒)</p>
                                                    </div>
                                                </div>
                                                <p style={{ margin: '8px 0 0 0', fontSize: '0.875rem', color: '#9fa2a3' }}>*服務費可以幫助 CELLWINE  保持穩定人力服務水準，其中包含專人專車搬運。 </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" id="delivery-fee" style={{ marginBottom: '24px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <h2>CELLWINE 出窖物流費</h2>
                                        <div className="row">
                                            <div className="col-12">
                                                <p style={{ color: '#4a4f55', margin: '8px 0 0 0', fontSize: '0.875rem' }}>若您使用與 CELLWINE 配合第三方宅配送酒服務，我們將依寄送瓶數向您酌收單次出窖物流費用 (按瓶計費)</p>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>1 瓶</th>
                                                                <th>2 至 6 瓶</th>
                                                                <th>7 至 12 瓶</th>
                                                                <th>13 至 18 瓶</th>
                                                                <th>19 至 24 瓶</th>
                                                                <th>24 瓶以上</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td valign="center">$190</td>
                                                                <td valign="center">$285</td>
                                                                <td valign="center">$385</td>
                                                                <td valign="center">$670</td>
                                                                <td valign="center">$770</td>
                                                                <td valign="center"><a href="https://bit.ly/2KDhJxV" target="_blank">客服報價</a></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <p style={{ margin: '0', fontSize: '0.875rem', color: '#9fa2a3' }}>*費用含出貨包材/作業手續費/第三方冷藏物流費</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" id="storage-fee" style={{ marginBottom: '24px' }}>
                                    <div className="col-sm-8 col-12 offset-sm-2" id="package-fee">
                                        <h2>親取包材費</h2>
                                        <div className="row">
                                            <div className="col-12">
                                                <p style={{ color: '#4a4f55', margin: '8px 0 0 0', fontSize: '0.875rem' }}>為響應環保，當您親取時若需要紙箱將向您酌收費用</p>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th colspan="4">紙箱</th>
                                                                <th>紙袋</th>
                                                            </tr>
                                                            <tr>
                                                                <th>1 瓶裝</th>
                                                                <th>3 瓶裝</th>
                                                                <th>6 瓶裝</th>
                                                                <th>12 瓶裝</th>
                                                                <th>2 瓶裝</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td valign="center">$10</td>
                                                                <td valign="center">$20</td>
                                                                <td valign="center">$30</td>
                                                                <td valign="center">$40</td>
                                                                <td valign="center">$10</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" id="refund-fee">
                                    <div className="col-sm-8 col-12 offset-sm-2">
                                        <h2>退貨處理費</h2>
                                        <div className="row">
                                            <div className="col-12">
                                                <p style={{ color: '#4a4f55', margin: '8px 0 0 0', fontSize: '0.875rem' }}>此費用將由物流公司向您收取現金</p>
                                                <div className="price">
                                                    <div className="detail">
                                                        <p>CELLWINE 處理費 $30／瓶</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        )
    }
}

export default PriceDetail
